<template>
    <!-- Eventually the users name will become a clickable link -->
    <!-- A small badge, which says 'Premium' the badge will be differently styled (greyed out/red if not -- green if so) dependent on status
    If you were to click on the badge, it would bring up a small dialog giving your premium subscribption details or how to get a premium sub -->
     <v-dialog
        v-model="dialog"
        width="500"
      >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
            :color="premiumEligible ? 'green' : 'red'"
            elevation="2"
            outlined
            rounded
            v-bind="attrs"
            v-on="on"
            >
            Premium?
            </v-btn>
        </template>
  
        <v-card>
          <v-card-title class="headline grey lighten-2">
            Toothcase Premium
          </v-card-title>
  
          <v-card-text>
              {{ premiumDialogTextBuilder }}
          </v-card-text>
  
          <v-divider></v-divider>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="dialog = false"
            >
              Okay
            </v-btn>
        </v-card-actions>
        </v-card>
    </v-dialog>
            
    <!-- FIND OUT MORE ABOUT PREMIUM (Would then link to the normal webpage's premium page) -->
</template>

<script>
export default {
    name: 'premiumBadge',
    data () {
        return {
            dialog: false,
        }
    },
    props: {
        premiumInfo: Object
    },
    computed: {
        premiumEligible(){
            //Add in another check for the subscription end date etc. To be thorough
            if (this.premiumInfo) {
                return this.premiumInfo.subscribed;
            }
            return false;
        },
        premiumDialogTextBuilder(){

        var text = "A Toothcase premium subscription... \n";

        if (this.premiumEligible)
        {
            text = text 
            + "You currently have a Toothcase Subscription and are therefore eligible for premium content!"
            + `\n Your active subsciption started: ${this.premiumInfo.subLastUpdated}`
            + `\n Your subscription is due to expire: ${this.premiumInfo.subEnd}`;
        } else {
            text = text 
            + "You do not currently have a Toothcase Subscription active. Premium Features you are missing out on are: \n" 
            + "\n Premium Articles"
            + "\n List some others"
            + "\n here...";
            //Maybe one day show the last time their subscription was active
        }

        text = text + "/n A Toothcase premium subscription can be obtained via your organisation or indvidually. Find more here: <INSERT LINK HERE>"

        return text;
        }
    },
    mounted(){   
    },
    methods: {
    }
}
</script>